import Avatar from '../../Avatar';
import { getFormattedAccessRight } from '../../../utils/miscFunctions';
import useUserAccount from '../../../hooks/userAccountHook';

interface UserInfoProps {
  isSidebarExpanded: boolean;
}

export default function UserInfo({ isSidebarExpanded }: UserInfoProps) {
  const { user } = useUserAccount();

  if (!isSidebarExpanded) return null;

  return (
    <div className="py-3 px-5 border-b border-gray-200 dark:border-darkBg-border">
      <div className="flex items-center space-x-3">
        <div className="bg-gray-300 dark:bg-darkBg-border rounded-full flex items-center justify-center">
          <div className={`w-auto rounded-full flex items-center justify-center ${user?.image == null ? 'bg-gray-200 dark:bg-darkBg-border p-3' : ''}`}>
            {user?.image ? (
              <Avatar customSize='w-[40px] h-[40px]' src={user?.image} nameInitials={user?.firstName} />
            ) : (
              <span className="text-sm font-medium text-gray-700 dark:text-darkBg-mainText">
                {user.firstName[0]}{user.lastName[0]}
              </span>
            )}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 dark:text-darkBg-mainText truncate">
            {user.firstName} {user.lastName}
          </p>
          <p className="text-xs text-gray-500 dark:text-darkBg-subText">
            {user.accessRight ? getFormattedAccessRight(user.accessRight) : '-'}
          </p>
        </div>
      </div>
    </div>
  );
}
